/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChecklisteIdentifier { 
    checkliste_id: string;
    funktionsbereich_id: string;
    mandant_id: string;
    modified_on_utc: Date;
}

